export function commonValidateRule(text) {
    return (val) => {
        return !['', undefined, null].includes(val) || text
    }
}
